function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { FETCH_ACTIVITIES_SUCCESS, FETCH_ACTIVITY_SUCCESS, UPLOAD_ACTIVITY_FILE_SUCCESS, CREATE_ACTIVITY_SUCCESS } from "../actions";
import initialState from "./initialState";
import { find, findIndex } from "lodash";
export default function activities() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.activities, action = arguments.length > 1 ? arguments[1] : void 0;
    var newActivities;
    switch(action.type){
        case FETCH_ACTIVITIES_SUCCESS:
            {
                if (Array.isArray(action.activities)) {
                    return _toConsumableArray(action.activities);
                } else {
                    return state;
                }
            }
        case FETCH_ACTIVITY_SUCCESS:
            {
                if (find(state, function(activity) {
                    return activity.id === action.activity.id;
                })) {
                    newActivities = state.slice();
                    var idx = findIndex(newActivities, function(activity) {
                        return activity.id === action.activity.id;
                    });
                    newActivities[idx] = action.activity;
                    return newActivities;
                } else {
                    newActivities = state.slice();
                    newActivities.push(action.activity);
                    return newActivities;
                }
            }
        case UPLOAD_ACTIVITY_FILE_SUCCESS:
            {
                newActivities = state.slice();
                if (action.result.type === "Activity") {
                    var idx1 = findIndex(newActivities, function(activity) {
                        return activity.id === action.result.target.id;
                    });
                    if (idx1 !== -1) {
                        newActivities[idx1] = action.result.target;
                    }
                }
                return newActivities;
            }
        case CREATE_ACTIVITY_SUCCESS:
            {
                // if (find(state, (activity) => activity.id === action.activity.id)) {
                //   newActivities = state.slice();
                //   const idx = findIndex(
                //     newActivities,
                //     (activity) => activity.id === action.activity.id,
                //   );
                //   newActivities[idx] = action.activity;
                //   return newActivities;
                // } else {
                newActivities = state.slice();
                if (action.activity) {
                    newActivities.push(action.activity);
                }
                return newActivities;
            // }
            }
        default:
            return state;
    }
}
